import SEO from "@/components/feature/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";

const testimonials = [
  {
    name: "张先生",
    role: "影视爱好者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20casual%20business%20attire%2C%20warm%20friendly%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=120&height=120&seq=avatar-1&orientation=squarish",
    comment: "红桃视频的画质真的非常出色，而且更新速度很快，基本上新片上映后很快就能看到。界面简洁好用，是我每天必用的视频平台。",
  },
  {
    name: "李女士",
    role: "全职妈妈",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20with%20gentle%20smile%2C%20warm%20portrait%20lighting%2C%20clean%20neutral%20background%2C%20natural%20pose&width=120&height=120&seq=avatar-2&orientation=squarish",
    comment: "自从朋友推荐了红桃视频，家里的电视基本就闲置了。内容特别丰富，从电视剧到综艺，从动画片到纪录片，全家人都能找到喜欢的内容。",
  },
  {
    name: "王同学",
    role: "大学生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20male%20student%2C%20friendly%20expression%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting&width=120&height=120&seq=avatar-3&orientation=squarish",
    comment: "分类很细致，找什么类型的内容都很方便。最喜欢的是没有广告打扰，播放体验特别流畅，宿舍同学都在用。",
  },
  {
    name: "赵女士",
    role: "上班族",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20woman%20in%20modern%20office%20attire%2C%20confident%20smile%2C%20clean%20studio%20background%2C%20soft%20professional%20lighting&width=120&height=120&seq=avatar-4&orientation=squarish",
    comment: "下班后的放松时间全靠红桃视频了。手机端和电脑端体验都很好，路上用手机看，回家用电脑看，无缝切换。",
  },
];

const stats = [
  { value: "5000+", label: "视频资源" },
  { value: "8", label: "内容分类" },
  { value: "1000万+", label: "月活用户" },
  { value: "4.9", label: "用户评分" },
];

const contactInfo = [
  { icon: "ri-mail-line", label: "电子邮箱", value: "contact@hongtao-video.com" },
  { icon: "ri-phone-line", label: "客服电话", value: "400-888-6666" },
  { icon: "ri-time-line", label: "服务时间", value: "周一至周日 9:00-21:00" },
  { icon: "ri-map-pin-line", label: "公司地址", value: "北京市朝阳区望京科技园A座" },
];

const faqs = [
  {
    question: "红桃视频需要下载安装吗？",
    answer: "红桃视频网页版无需下载安装任何软件或插件，直接使用浏览器打开网站即可观看高清视频。支持Chrome、Safari、Edge等主流浏览器。",
  },
  {
    question: "红桃视频支持哪些设备观看？",
    answer: "红桃视频支持PC端（Windows/Mac）和手机端（iOS/Android）通过浏览器访问。我们的网站采用响应式设计，自动适配不同屏幕尺寸，确保在任何设备上都能获得良好的观看体验。",
  },
  {
    question: "视频画质如何？是否支持高清播放？",
    answer: "红桃视频提供多种画质选择，最高支持1080P全高清画质播放。系统会根据您的网络状况自动选择最佳画质，同时也支持手动切换画质。",
  },
  {
    question: "红桃视频是否收费？",
    answer: "红桃视频网页版完全免费，所有视频内容均可免费在线观看，无隐藏收费项目。我们致力于为用户提供优质的免费视频服务。",
  },
  {
    question: "新内容更新频率如何？",
    answer: "红桃视频保持着高频率的内容更新，热门影视剧集通常在播出后24小时内完成更新。综艺和动漫内容也会在第一时间同步更新，确保用户不错过任何精彩内容。",
  },
];

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 - 品牌介绍 | 红桃视频网页版"
        description="红桃视频网页版品牌介绍，了解我们的发展历程、核心优势和用户口碑。红桃视频致力于为用户提供免费高清在线视频观看服务。"
        keywords="红桃视频网页版,红桃视频关于我们,红桃视频品牌介绍,红桃视频联系方式"
        canonical="https://www.hongtao-video.com/about"
      />

      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于红桃视频网页版",
            url: "https://www.hongtao-video.com/about",
            description: "红桃视频网页版品牌介绍，了解我们的发展历程和核心优势",
            isPartOf: { "@type": "WebSite", name: "红桃视频网页版", url: "https://www.hongtao-video.com/" },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          }),
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-16">
          <div className="bg-background-100">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>

          <section className="w-full px-4 md:px-6 py-10 md:py-16">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                关于红桃视频
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                红桃视频网页版成立于2024年，是一家专注于提供免费高清在线视频服务的平台。我们致力于为广大用户提供丰富、优质、便捷的视频观看体验。
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
                {stats.map((stat) => (
                  <div key={stat.label} className="bg-background-100 rounded-xl p-5">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500" style={{ fontFamily: "var(--font-heading)" }}>
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
                品牌介绍
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-eye-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">我们的愿景</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    成为中文互联网最受欢迎的免费视频平台，让每个人都能轻松享受高品质的视频娱乐体验。我们相信，优质的视频内容应该对所有人开放。
                  </p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-star-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">核心优势</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    海量高清资源、流畅播放体验、多终端无缝切换、及时的内容更新——这些都是我们引以为傲的服务标准，也是数百万用户选择我们的理由。
                  </p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">品质保障</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    所有视频内容均经过严格审核，确保画质清晰、内容健康。我们持续优化播放技术，为用户提供稳定、流畅的观看体验。
                  </p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-rocket-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">技术驱动</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    采用先进的视频编码和CDN加速技术，确保视频加载迅速、播放流畅。自适应码率技术让不同网络环境下的用户都能获得最佳体验。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {testimonials.map((t) => (
                  <div key={t.name} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={t.avatar}
                          alt={t.name}
                          title={t.name}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.role}</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{t.comment}</p>
                    <div className="flex gap-1 mt-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
                常见问题
              </h2>
              <div className="flex flex-col gap-3">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm font-semibold text-foreground-950 pr-4">{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {contactInfo.map((info) => (
                  <div key={info.label} className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
                      <i className={`${info.icon}`}></i>
                    </div>
                    <p className="text-xs text-foreground-400 mb-1">{info.label}</p>
                    <p className="text-sm font-medium text-foreground-950">{info.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}